import {JSX} from "react";

export default function Loading(): JSX.Element {
    return <h5 style={{color:"white"}}>Loading...</h5>;
}